import React from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';

import Popover from 'react-popover';

import { Container, DataContainer, DataParentContainer, ExtraContainer, MaxPercentInfoIcon, PopoverContent, StyledHeaders, StyledInputLabelSideBySide, StyledTestSetsButtonGroup, TestContainer, TestDataContainer, TestDataParentContainer, TestInnerContainer } from './styles';

import ButtonGroup from '../Buttons/ButtonGroup';
import MultiText from '../Text/MultiText';
import PageText from '../Text/PageText';
import Spacer from '../Spacer';

import Info from '../../Assets/Icons/Info.png';

import { SecondsToMinutesAndSeconds, SecondsToTime } from '../../Functions';

class ExerciseTypeOne extends React.Component {
    TimeoutId = null;

    state = {
        BreakMinutes: '',
        BreakSeconds: '',
        MaxReps: '',
        OriginalBreak: 0,
        OriginalReps: +this.props.Reps,
        PopoverIsOpen: false,
        Reps: this.props.Reps,
        TotalBreak: ''
    };

    componentDidMount() {
        var { BreakTime } = this.props;

        if (BreakTime !== '') {
            var { Minutes: BreakMinutes, Seconds: BreakSeconds } = SecondsToMinutesAndSeconds(BreakTime);

            BreakSeconds = +BreakSeconds === 0 ? '00' : +BreakSeconds < 10 ? `0${BreakSeconds}` : BreakSeconds;

            this.setState({ BreakMinutes, BreakSeconds, OriginalBreak: BreakTime, TotalBreak: BreakTime });
        }
    }

    componentDidUpdate(prevProps) {
        if (this.props.SetType !== 'Test') {
            var { BreakTime: PrevBreakTime, Reps: PrevReps } = prevProps;
            var { BreakTime: CurrBreakTime, Reps: CurrReps } = this.props;

            PrevBreakTime = +PrevBreakTime;
            PrevReps = +PrevReps;
            CurrBreakTime = +CurrBreakTime;
            CurrReps = +CurrReps;

            if (PrevReps !== CurrReps) this.setState({ OriginalReps: CurrReps, Reps: CurrReps });
            if (PrevBreakTime !== CurrBreakTime) {
                var { Minutes: BreakMinutes, Seconds: BreakSeconds } = SecondsToMinutesAndSeconds(CurrBreakTime);

                BreakSeconds = +BreakSeconds === 0 ? '00' : +BreakSeconds < 10 ? `0${BreakSeconds}` : BreakSeconds;

                this.setState({ BreakMinutes, BreakSeconds, OriginalBreak: CurrBreakTime, TotalBreak: CurrBreakTime });
            }
        }
    }

    onBlurBreakTime = () => {
        var TotalBreak = 0;
        TotalBreak += (this.state.BreakMinutes * 60) + +this.state.BreakSeconds;

        var { Minutes: BreakMinutes, Seconds: BreakSeconds } = SecondsToMinutesAndSeconds(TotalBreak);

        BreakSeconds = +BreakSeconds === 0 ? '00' : +BreakSeconds < 10 ? `0${BreakSeconds}` : BreakSeconds;
        BreakMinutes = +BreakMinutes === 0 ? 0 : BreakMinutes;

        if (+TotalBreak !== +this.state.OriginalBreak) this.setState({ BreakMinutes, BreakSeconds, TotalBreak }, () => this.onUpdateWorkoutSet());
        else this.setState({ BreakMinutes, BreakSeconds, TotalBreak });
    }

    onBlurMaxReps = () => {
        var { MaxReps } = this.state;

        if (+MaxReps === 0) this.setState({ MaxReps: 0 });
    }

    onBlurReps = () => {
        var { OriginalReps, Reps } = this.state;

        if (+Reps === 0) this.setState({ Reps: 0 });

        if (+OriginalReps !== +Reps) this.onUpdateWorkoutSet();
    }

    onChangeMaxReps = event => {
        this.setState({ MaxReps: event.target.value });
    }

    onChangeReps = event => {
        this.setState({ Reps: event.target.value });
    }

    onChangeTime = (event, TimeType, OtherTimeTypeValue) => {
        var TotalBreak = 0;
        if (TimeType === 'Minutes') TotalBreak += (event.target.value * 60) + OtherTimeTypeValue;
        else if (TimeType === 'Seconds') TotalBreak += event.target.value + (OtherTimeTypeValue * 60);

        this.setState({ [`Break${TimeType}`]: event.target.value, TotalBreak });
    }

    onRegenerateMax = () => {
        this.props.OnRegenerateMax(this.state.MaxReps);
    }

    onTogglePopover = () => {
        this.setState({ PopoverIsOpen: !this.state.PopoverIsOpen }, () => {
            if (!this.state.PopoverIsOpen && !!this.TimeoutId) clearTimeout(this.TimeoutId);
        });
    }

    onUpdateWorkoutSet = () => {
        var { Reps, TotalBreak } = this.state;

        this.setState({ OriginalBreak: TotalBreak, OriginalReps: Reps }, () => this.props.OnUpdateWorkoutSet({ Reps, TotalBreak }));
    }

    renderAddMax = () => {
        var { t } = this.props;
        var { Device, Units } = this.props;
        var { MaxReps } = this.state;

        var Disabled = !+MaxReps;

        var Buttons = [
            { BackgroundColor: 'blue-astronaut', BackgroundColorHover: 'blue-astronaut-hover', Color: 'white', ColorHover: 'white', FontFamily: 'semibold', OnClick: () => this.props.OnUpdateTestSetScreen('Description'), Title: t('back_with_first_char_uppercase') },
            { BackgroundColor: 'blue-abel', BackgroundColorHover: 'blue-abel-hover', Color: 'white', ColorHover: 'white', Disabled, FontFamily: 'semibold', OnClick: this.onRegenerateMax, Title: t('regenerate') }
        ]

        return (
            <>
                <TestContainer className="TestContainer">
                    <TestInnerContainer className="TestInnerContainer">
                        <PageText FontFamily="medium" FontSize="medium-1" JustifyContent="flex-start" NoMargin Text={`${t('Users_max')}:`} TextAlign="left" />

                        <TestDataParentContainer className="TestDataParentContainer">
                            <TestDataContainer className="TestDataContainer">
                                <StyledInputLabelSideBySide
                                    InputFontFamily="semibold"
                                    InputFontSize="medium-2"
                                    LabelFontFamily="medium"
                                    LabelFontSize="medium-1"
                                    Label={Units.toLowerCase()}
                                    OnBlur={this.onBlurMaxReps}
                                    OnChange={this.onChangeMaxReps}
                                    Placeholder="0"
                                    Type="number"
                                    Value={MaxReps}
                                />
                            </TestDataContainer>
                        </TestDataParentContainer>
                    </TestInnerContainer>

                    {
                        (Device === 'laptop' || Device === 'ipad') &&
                        <StyledTestSetsButtonGroup
                            Buttons={Buttons}
                            ButtonWidth="fit-content"
                            NotTouching
                        />
                    }
                </TestContainer>

                {
                    (Device === 'mobile' || Device === 'mobile_small') &&
                    <>
                        <Spacer Size="extra-small" />

                        <ButtonGroup
                            Buttons={Buttons}
                            ButtonWidth="fit-content"
                            NotTouching
                        />
                    </>
                }
            </>
        );
    }

    renderPopoverContent = () => {
        var { t } = this.props;

        return (
            <PopoverContent className="PopoverContent">
                <PageText FontFamily="medium-italic" FontSize="medium-1" JustifyContent="center" NoMargin Text={t('dynamic_sets_estimate_to_be_around_X_percent_popover_noreps', { Percent: `100` })} TextAlign="center" />
            </PopoverContent>
        );
    }

    render() {
        var { t } = this.props;
        var { Device, InnerWidth, Completed, DataType, EditingSet, MaxSet, MaxType, ReadOnly, SetType, Units } = this.props;
        var { BreakMinutes, BreakSeconds, Reps, TotalBreak } = this.state;

        if (SetType === 'Test') return this.renderAddMax();

        const popoverProps = {
            isOpen: this.state.PopoverIsOpen,
            preferPlace: 'below',
            onOuterAction: this.onTogglePopover,
            body: this.renderPopoverContent(),
            tipSize: 0.01
        }

        // Add % text if template and dynamic
            var ExerciseTypeColumnText = '';
            if (SetType === 'Template' && DataType !== 'static' && (MaxType === 'Custom' || DataType === 'dynamic-reps')) ExerciseTypeColumnText = t('percent_of_max', { MeasureType: t('Reps').toLowerCase() });
            else ExerciseTypeColumnText = t('Reps');

        return (
            <Container className="Container" Completed={Completed} MaxSet={MaxSet}>
                <DataParentContainer className="DataParentContainer" BorderColor={MaxSet && !Completed && 'var(--orange)'}>
                    {
                        InnerWidth > 900 && SetType === 'Template' && DataType === 'dynamic-reps' && (MaxType === 'Custom' || !MaxSet) &&
                        <Popover {...popoverProps}>
                            <MaxPercentInfoIcon ImageSrc={Info} OnMouseEnter={this.onTogglePopover} OnMouseLeave={this.onTogglePopover} />
                        </Popover>
                    }

                    <DataContainer className="DataContainer" Completed={Completed} MaxSet={MaxSet}>
                        <StyledHeaders FontFamily="bold" FontSize="medium-1" NoMargin Text={ExerciseTypeColumnText} />

                        {
                            SetType === 'Template' && MaxType !== 'Custom' && DataType === 'dynamic-reps' && !!MaxSet ?
                            <PageText FontFamily="medium-italic" FontSize="medium-1" JustifyContent={(Device === 'mobile' || Device === 'mobile_small') ? 'flex-end' : 'center'} NoMargin Text={t('dynamic_sets_estimate_to_be_around_X_percent', { Percent: '101'})} TextAlign={(Device === 'mobile' || Device === 'mobile_small') ? 'right' : 'center'} />
                        :
                            // (ReadOnly || (Completed && ((!EditingSet && MaxSet) || !MaxSet))) ?
                            (ReadOnly || (Completed && !EditingSet)) ?
                            <MultiText
                                Texts={[
                                    { FontFamily: 'semibold', FontSize: 'medium-3', Text: `${Reps}` },
                                    { FontFamily: 'medium', FontSize: 'medium-1', Text: `${Units.toLowerCase()}` }
                                ]}
                            />
                        :
                            <ExtraContainer className="ExtraContainer">
                                {
                                    InnerWidth <= 900 && SetType === 'Template' && DataType === 'dynamic-reps' && (MaxType === 'Custom' || !MaxSet) &&
                                    <Popover {...popoverProps}>
                                        <MaxPercentInfoIcon ImageSrc={Info} OnMouseEnter={this.onTogglePopover} OnMouseLeave={this.onTogglePopover} />
                                    </Popover>
                                }

                                <StyledInputLabelSideBySide
                                    InputFontFamily="semibold"
                                    InputFontSize="medium-2"
                                    LabelFontFamily="medium"
                                    LabelFontSize="medium-1"
                                    Label={Units.toLowerCase()}
                                    OnBlur={this.onBlurReps}
                                    OnChange={this.onChangeReps}
                                    Placeholder="0"
                                    Type="number"
                                    Value={Reps}
                                />
                            </ExtraContainer>
                        }
                    </DataContainer>
                </DataParentContainer>

                <DataParentContainer className="DataParentContainer">
                    <DataContainer className="DataContainer" Completed={Completed} MaxSet={MaxSet}>
                        <StyledHeaders FontFamily="bold" FontSize="medium-1" NoMargin Text={t('break')} />

                        {
                            (ReadOnly || Completed) ?
                            <PageText FontFamily="semibold" FontSize="medium-3" NoMargin Text={SecondsToTime(TotalBreak)} />
                        :
                            <StyledInputLabelSideBySide
                                InputFontFamily="semibold"
                                InputFontSize="medium-2"
                                LabelFontFamily="medium"
                                LabelFontSize="medium-1"
                                Label={`${t('min_str').toLowerCase()} / ${t('Seconds_short').toLowerCase()}`}
                                OnBlur={this.onBlurBreakTime}
                                OnChange={(event, TimeType, OtherTimeTypeValue) => this.onChangeTime(event, TimeType, OtherTimeTypeValue)}
                                Placeholder="0"
                                TimeValueMinutes={BreakMinutes}
                                TimeValueSeconds={BreakSeconds}
                                Type="time"
                            />
                        }
                    </DataContainer>
                </DataParentContainer>
            </Container>
        )
    }
}

ExerciseTypeOne.propTypes = {
    BreakTime: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number
    ]),
    Completed: PropTypes.bool,
    DataType: PropTypes.string,
    EditingSet: PropTypes.bool,
    MaxSet: PropTypes.bool,
    MaxType: PropTypes.string,
    Reps: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number
    ]),
    OnRegenerateMax: PropTypes.func,
    OnUpdateTestSetScreen: PropTypes.func,
    OnUpdateWorkoutSet: PropTypes.func,
    ReadOnly: PropTypes.bool,
    SetType: PropTypes.string.isRequired,
    Units: PropTypes.string
}

const mapStateToProps = state => {
    return {
        Device: state.Window.Device,
        InnerWidth: state.Window.InnerWidth
    };
};

export default withTranslation()(connect(mapStateToProps, { } )(ExerciseTypeOne));